module.exports = __webpack_public_path__ + "img/studyimg4.721db3db.jpg";